"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInvitationStatus = void 0;
var UserInvitationStatus;
(function (UserInvitationStatus) {
    UserInvitationStatus[UserInvitationStatus["New"] = 0] = "New";
    UserInvitationStatus[UserInvitationStatus["Revoked"] = 1] = "Revoked";
    UserInvitationStatus[UserInvitationStatus["Accepted"] = 2] = "Accepted";
})(UserInvitationStatus = exports.UserInvitationStatus || (exports.UserInvitationStatus = {}));
//# sourceMappingURL=UserInvitationStatus.js.map